<div class="modal-header">
    <h4 class="modal-title">ANC – Antenatal Care</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="card-body" [formGroup]="ancForm">
        <div class="row">
            <div class="col-xl-3 mb-2">
                <label>Gravida / Para</label>
                <!-- (click)="isOtherSelected($event.target.value)" -->
                <select class="form-control form-control-sm" formControlName="gravida_para_id" >
                    <option value=null>Select</option>
                   <option *ngFor="let opt of gravidaList" [value]="opt.id">{{ opt.name }}</option>

                </select>
            </div>
            <!-- <div class="col-xl-3 mb-2" *ngIf="enableOtherGravida">
                 <label>Other Gravida / Para</label>
                <input class="form-control form-control-sm" formControlName="gravidaOther"
                    placeholder="Enter other gravida">
            </div> -->
            <div class="col-xl-3 mb-2">
                <label>Pregnancy Trimester</label>
                <select class="form-control form-control-sm" formControlName="pregnancy_trimester">
                    <option value=null>Select</option>
                     <option *ngFor="let opt of trimesterOptions" [value]="opt">{{ opt }}</option>
                </select>
            </div>
            <div class="col-xl-3 mb-2">
                <label>IFA Given</label>
               <div>
                <input type="radio" formControlName="if_given" [value]="true" class="ml-2 mr-2">Yes
                <input type="radio" formControlName="if_given" [value]="false" class="ml-2 mr-2">No
              </div>
            </div>
            <div class="col-xl-3 mb-2">
                <label>TT Injection Given</label>
                <select class="form-control form-control-sm" formControlName="tt_injection_given_id">
                    <option value=null>Select</option>
                   <option *ngFor="let opt of ttList" [value]="opt.id">{{ opt.name }}</option>

                </select>
            </div>
            <div class="col-xl-3 mb-2">
                <label>High-Risk Pregnancy</label>
                <div>
                <input type="radio" formControlName="high_risk_pregnancy" [value]="true" class="ml-2 mr-2" (click)="highriskPregenancy(true)">Yes
                <input type="radio" formControlName="high_risk_pregnancy" [value]="false" class="ml-2 mr-2" (click)="highriskPregenancy(false)">No
              </div>
            </div>

            <div class="col-xl-3 mb-2"  *ngIf="enableHighRiskReason">
                <label>Reason for High Risk</label>
                <select class="form-control form-control-sm" formControlName="highrisk_reason_id" (click)="isOtherSelectedReason($event.target.value)">
                    <option value=null>Select</option>
                    <option *ngFor="let opt of highriskList" [value]="opt.id">{{ opt.name }}</option>

                </select>
            </div>
            <div class="col-xl-3 mb-2" *ngIf="enableOtherReason">
                 <label>Other Reason for High Risk</label>
                <input class="form-control form-control-sm" formControlName="if_others_highrisk_reason"
                    placeholder="Enter other reason">
            </div>

            <!-- <div class="col-xl-3 mb-2">
                <label>Referred To</label>
                <select class="form-control form-control-sm" formControlName="consult_refer_to_id">
                  <option value=null>Select</option>
                    <option *ngFor="let opt of referredist" [value]="opt.id">{{ opt.name }}</option>

                </select>
            </div>  -->
        </div>

    </div>
</div>
<div class="modal-footer">
    <button type="button" id="saveButton" class="btn btn-primary btn-sm" (click)="onSave()">Save</button>

    <button type="button" id="closeButton" class="btn btn-outline-dark btn-sm"
        (click)="activeModal.close('Close click')">Close</button>
</div>